import { IApiPagination } from "../interfaces/IPagination";
import {
  ApiOrderResponse,
  ApiResponse,
} from "../interfaces/apiResponseInterface";
import {
  IOrderFilter,
  OrderCalculationResult,
  OrderInterface,
} from "../interfaces/orderInterface";
import { UseProductOrderCalculation } from "../pages/orders/hooks/useProductOrderCalculationQuery";
import axiosTeethTab from "./apiCall";

interface IInvoice {
  file: string;
  fileName: string;
}

interface OrderApiInterface {
  getOrders: (
    filter: IOrderFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<ApiOrderResponse<OrderInterface>>>;
  saveOrders: (order: OrderInterface) => Promise<ApiResponse<OrderInterface>>;
  getLastNoOrder: () => Promise<ApiResponse<number>>;
  getInvoice: (orderId: string) => Promise<ApiResponse<IInvoice>>;
  getOrder: (orderId: string) => Promise<ApiResponse<OrderInterface>>;
  calculatedOrder: (
    opt: Omit<UseProductOrderCalculation, "enabled">,
  ) => Promise<ApiResponse<OrderCalculationResult>>;
}

const orderApi: OrderApiInterface = {
  getOrders: async (filter: IOrderFilter, pagination: IApiPagination) => {
    const endpoint = "orders";
    return await axiosTeethTab.get<ApiOrderResponse<OrderInterface>>(endpoint, {
      params: {
        filter,
        pagination,
      },
    });
  },
  saveOrders: async (order) => {
    const isUpdatingOrder = !!order._id;
    const endpoint = isUpdatingOrder ? `orders/${order._id}` : "orders";
    if (isUpdatingOrder)
      return await axiosTeethTab.patch<OrderInterface>(endpoint, order);
    return await axiosTeethTab.post<OrderInterface>(endpoint, order);
  },
  getLastNoOrder: async () => {
    const endpoint = "orders/next";
    return await axiosTeethTab.get<number>(endpoint);
  },
  getOrder: async (orderId: string) => {
    const endpoint = `orders/${orderId}`;
    return await axiosTeethTab.get<OrderInterface>(endpoint);
  },
  getInvoice: async (orderId: string) => {
    const endpoint = `orders/${orderId}/invoice`;
    return await axiosTeethTab.get(endpoint, {});
  },
  calculatedOrder: async (opt: UseProductOrderCalculation) => {
    const endpoint = `orders/calculate`;
    return await axiosTeethTab.post(endpoint, opt);
  },
};

export default orderApi;
